import { AfterViewInit, Directive, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { ICalendarOptions } from '@df/ui/form/calendar.component.def';
import { Nexus } from '@tomandco/nexus-api-types';

/**
 * WARNING: please note this is NOT to be used with product configuration
 */
@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export abstract class GiftcardsProductComponentDef<T extends Product<IProductDataV3> = Product<IProductDataV3>>
    extends ProductComponentDef<T>
    implements AfterViewInit
{
    deliveryTo?: Giftcards.VirtualType;

    override request!: Giftcards.ISelectionContainer & Nexus.Lib.Basket.AddToBasketData & Giftcards.IInjectedPart;

    calendarOptions: ICalendarOptions = {
        min: new Date(new Date().setHours(0, 0, 0, 0))
    };

    /**
     * Form
     * important: you need to put #form="ngForm" on form element in template
     */

    @ViewChild('form', { static: false })
    form?: NgForm;

    ngAfterViewInit() {
        if (this.form) {
            this.subscriptions.add(this.form.statusChanges!.subscribe(() => this.detectChanges()));
            this.subscriptions.add(this.form.ngSubmit.subscribe(() => this.detectChanges()));
        }
    }

    protected override onModelChange(): void {
        super.onModelChange();

        if (!this.model?.isConfigurable) {
            this.resetRequest();
        }
    }

    get isVirtual(): boolean {
        return !!this.model?.giftCard?.isVirtual();
    }

    get isPhysical(): boolean {
        return !!this.model?.giftCard?.isPhysical();
    }

    resetRequest(virtualType?: Giftcards.VirtualType | string): void {
        const giftcardImageCode = this.model?.data?.am_giftcard_code_image;

        if (giftcardImageCode && this.request) {
            this.request.am_giftcard_image = giftcardImageCode[0];
        }

        const propsToDelete: (keyof Giftcards.ISelectionContainer | string)[] = [
            'am_giftcard_date_delivery',
            'am_giftcard_recipient_email',
            'am_giftcard_recipient_name',
            'am_giftcard_sender_name',
            'am_giftcard_sender_email'
        ];

        if (this.request) {
            if (this.isPhysical || virtualType === Giftcards.VirtualType.SendToMe) {
                propsToDelete.forEach(prop => delete this.request![prop]);
                delete this.request.am_giftcard_message;
            }

            if (this.isPhysical) {
                delete this.request.am_giftcard_message;
            }
        }
        this.onRequestChange();
    }

    onRequestChange() {
        this.detectChanges();
    }
}
